import BaseResult from '@jbrowse/core/TextSearch/BaseResults';
export function dedupe(results = [], cb) {
    return results.filter((elt, idx, self) => idx === self.findIndex(t => cb(t) === cb(elt)));
}
export async function fetchResults({ queryString, searchType, searchScope, rankSearchResults, textSearchManager, assembly, }) {
    var _a;
    if (!textSearchManager) {
        console.warn('No text search manager');
    }
    const textSearchResults = await (textSearchManager === null || textSearchManager === void 0 ? void 0 : textSearchManager.search({
        queryString,
        searchType,
    }, searchScope, rankSearchResults));
    const refNameResults = (_a = assembly === null || assembly === void 0 ? void 0 : assembly.allRefNames) === null || _a === void 0 ? void 0 : _a.filter(ref => ref.toLowerCase().startsWith(queryString.toLowerCase())).slice(0, 10).map(r => new BaseResult({ label: r }));
    return dedupe([...(refNameResults || []), ...(textSearchResults || [])], elt => elt.getId());
}
//# sourceMappingURL=util.js.map